
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"23","height":"23","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"23","height":"23","rx":"4","fill":"#5E0DF5"}}),_c('path',{attrs:{"d":"M16 17l-2.59-3.693c1.53-.55 2.403-1.776 2.403-3.473C15.813 7.446 14.097 6 11.258 6H7v11h1.56v-3.347h2.698c.234 0 .468-.016.687-.032L14.3 17H16zm-4.789-4.683H8.56v-4.95h2.651c1.997 0 3.042.896 3.042 2.467 0 1.572-1.045 2.483-3.042 2.483z","fill":"#fff"}})])
          )
        }
      }
    